import React from 'react';

import ContentCard from '../ContentCard/ContentCard';

// IMPORT STYLES
import './ContentList.css';

import {
  ABOUT_ME,
  BLOG,
  CONSULT
} from './constants';

function ContentList() {

  return(
    <div className='contentList'>
      <ContentCard {...ABOUT_ME} />
      <ContentCard {...BLOG} />
      <ContentCard {...CONSULT} />
    </div>
  );
}
export default ContentList;
